/**
 * Formats a given price or amount into Indian Rupees format (en-IN).
 * Examples:
 *   19000 -> "19,000"
 *   1000 -> "1,000"
 *   150000 -> "1,50,000"
 * 
 * @param {number|string} amount - The price or amount to format.
 * @param {boolean} [includeSymbol=false] - Whether to prepend the "₹" symbol.
 * @returns {string} Formatted price string.
 */
export const formatPrice = (amount, includeSymbol = false) => {
  if (amount === null || amount === undefined || amount === '') return '';

  const cleanStr = String(amount).trim();
  const num = Number(cleanStr);
  if (isNaN(num)) return String(amount);

  const formatted = num.toLocaleString('en-IN');
  return includeSymbol ? `₹${formatted}` : formatted;
};

export const formatCurrency = (amount) => formatPrice(amount, true);
